<template>
  <div class="animated" v-if="schedule">
    <b-progress :max="max" height="1rem">
      <b-progress-bar :value="value" :variant="variant">
        <strong>{{ value }} / {{ max }}</strong>
      </b-progress-bar>
    </b-progress>
  </div>
</template>

<script>
import InstrumentCollection from "@/collections/lab/InstrumentCollection";
import ScheduleModel from "@/models/lab/ScheduleModel";
import SampleCollection from "@/collections/lab/SampleCollection";

export default {
  name: "ScheduleCapacityBar",
  props: {
    schedule: {
      type: ScheduleModel,
      default: () => null
    }
  },
  data() {
    return {
      max: 0,
      value: 0,
      variant: null
    };
  },
  methods: {
    getInstruments() {
      if (this.schedule) {
        let process = this.schedule.getProcessSchedules().first();
        if (process) {
          let instrumentInstances = process.getInstrumentInstances();
          if (instrumentInstances && instrumentInstances.length) {
            let instruments = instrumentInstances.getInstruments();
            if (instruments && instruments.length) {
              return instruments;
            }
          }
        }
      }
      return new InstrumentCollection();
    },
    getSamples() {
      if (this.schedule) {
        let process = this.schedule.getProcessSchedules().first();
        if (process) {
          let samples = process.getSamples();
          if (samples && samples.length) {
            return samples;
          }
        }
      }
      return new SampleCollection();
    },
    runtimeSeconds(instrument) {
      switch (instrument.runtime_display) {
        case "hours":
          return Math.abs(instrument.runtime) * 3600;
        case "minutes":
          return Math.abs(instrument.runtime) * 60;
        case "seconds":
          return Math.abs(instrument.runtime);
      }
      return null;
    },
    dailyCapacity(instrument) {
      const runtime_seconds = this.runtimeSeconds(instrument);
      return Math.floor(32400 / runtime_seconds) * instrument.capacity;
    },
    init() {
      const instruments = this.getInstruments();
      
      this.max = instruments
        .map(x => /*x.capacity*/ {
          return this.dailyCapacity(x);
        })
        .reduce((x, i) => {
          return x + +i;
        });

      const samples = this.getSamples();

      this.value = samples.models.length;

      if (this.value / this.max >= 0.8) {
        this.variant = "success";
      } else if (this.value / this.max >= 0.6) {
        this.variant = null;
      } else if (this.value / this.max >= 0.4) {
        this.variant = "warning";
      } else {
        this.variant = "danger";
      }
    }
  },

  created() {
    this.init();
  }
};
</script>
